module.exports = "/_next/static/images/e4e7c4372cd4ea89611755ea1a4ada91-phone-and-card@md-2x.jpg.webp";